
import TireFitmentVehicles from './TireFitmentVehicles.vue';
import TireSizeLookupForm from './TireSizeLookupForm.vue';
import TransitionExpand from 'JS/components/transitions/TransitionExpand.vue';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
	name: 'TireFitmentLookup',
	components: {
		TransitionExpand,
		TireFitmentVehicles,
		TireSizeLookupForm
	}
})
class TireFitmentLookup extends Vue {

	$refs!: {
		sizeTab: HTMLButtonElement,
		vehicleTab: HTMLButtonElement
	}

	/* Data
	============================================*/

	activeTab: 'vehicle' | 'size' = 'vehicle';

	/* Methods
	============================================*/

	handleTabKeydown(e: KeyboardEvent) {
		// https://www.w3.org/TR/wai-aria-practices/examples/tabs/tabs-1/tabs.html#kbd_label
		switch (e.key) {
			case 'Home':
				e.preventDefault();
				this.activeTab = 'vehicle';
				this.$refs.vehicleTab?.focus();
				break;
			case 'End':
				e.preventDefault();
				this.activeTab = 'size';
				this.$refs.sizeTab?.focus();
				break;
			default:
				break;
		}
	}

	handleTabKeyup(e: KeyboardEvent) {
		switch (e.key) {
			case 'ArrowLeft':
			case 'ArrowRight':
				if (this.activeTab === 'vehicle') {
					this.activeTab = 'size';
					this.$refs.sizeTab?.focus();
				} else {
					this.activeTab = 'vehicle';
					this.$refs.vehicleTab?.focus();
				}
				break;
			default:
				break;
		}
	}
}

export default TireFitmentLookup;
